var googleRecaptchaScript
const WEB_KEY = '6Le0_jgrAAAAAPQqpQ1JAvKPags1xpCTAclvFLIT'
export default {
  methods: {
    loadGoogleRecaptchaScript(success = () => {}) {
      // console.log(publicKey)
      if (!googleRecaptchaScript) {
        googleRecaptchaScript = window.document.createElement('script')
        googleRecaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${WEB_KEY}`
        googleRecaptchaScript.onload = () => {
          grecaptcha.enterprise.ready(async () => {
            const token = await grecaptcha.enterprise.execute(WEB_KEY, { action: 'LOGIN' });
            success && success(token)
          })
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(googleRecaptchaScript, head.firstChild)
      } else {
        grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute(WEB_KEY, { action: 'LOGIN' });
          success && success(token)
        })
      }
    }
  }
}
